import React from 'react';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Borrado',
    desc: 'Aplicas la purga sensorial de 60 segundos para bajar las revoluciones de tu sistema nervioso.'
  }, {
    num: '2',
    title: 'Vaciado',
    desc: 'Trasladas el ruido cognitivo al papel para liberar espacio en tu procesador mental.'
  }, {
    num: '3',
    title: 'Carga',
    desc: 'Ejecutas el micro-paso de 2 minutos que rompe la inercia de la parálisis de forma definitiva.'
  }];
  return <section className="py-24 relative" data-id="element-63">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-64">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-50 mb-16 text-center" data-id="element-65">
          Cómo funciona en 3 pasos
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-66">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-gradient-to-r from-cyan-500/0 via-cyan-500/30 to-cyan-500/0" data-id="element-67" />

          {steps.map((step, index) => <div key={index} className="relative flex flex-col items-center text-center group" data-id="element-68">
              <div className="w-24 h-24 rounded-full bg-[#0A0A0F] border-2 border-cyan-500/30 flex items-center justify-center text-3xl font-bold text-cyan-400 mb-6 shadow-[0_0_20px_rgba(34,211,238,0.1)] group-hover:border-cyan-400 group-hover:shadow-[0_0_30px_rgba(34,211,238,0.3)] transition-all duration-300 relative z-10" data-id="element-69">
                {step.num}
              </div>
              <h3 className="text-2xl font-bold text-slate-100 mb-4" data-id="element-70">
                {step.title}
              </h3>
              <p className="text-slate-400 leading-relaxed max-w-xs" data-id="element-71">
                {step.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}